<nav
  class="bg-white dark:bg-gray-900 fixed w-full z-20 top-0 start-0 border-b border-gray-200 dark:border-gray-600"
  [class.iOS]="ios"
>
  <div
    class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4"
  >
    <div class="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
      <button
        *ngIf="isAuthenticated()"
        tian-collapse-toggle="navbar-sticky"
        type="button"
        class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
        aria-controls="navbar-sticky"
        aria-expanded="false"
      >
        <span class="sr-only">Open main menu</span>
        <svg
          class="w-5 h-5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 17 14"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M1 1h15M1 7h15M1 13h15"
          />
        </svg>
      </button>
      <a
        (click)="collapseNavbar()"
        *ngIf="isAuthenticated()"
        routerLink="/chat"
        class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >Chat</a
      >
    </div>
    <a
      (click)="collapseNavbar()"
      routerLink="/"
      class="flex items-center space-x-3 rtl:space-x-reverse"
    >
      <img
        [src]="
          this.darkMode ? '/images/logo_dark.png' : '/images/logo_light.png'
        "
        class="h-8"
        alt="eScout Logo"
      />
    </a>
    <div
      (click)="collapseNavbar()"
      class="hidden items-center justify-between w-full md:flex md:w-auto md:order-1"
      id="navbar-sticky"
    >
      <ul
        class="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700"
      >
        <li>
          <a
            routerLink="/"
            routerLinkActive="bg-blue-700 "
            class="block py-2 px-3 text-white rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500"
            aria-current="page"
            >Inicial</a
          >
        </li>
        <li *ngIf="isAuthenticated()">
          <a
            routerLink="/profile"
            routerLinkActive="bg-blue-700 "
            class="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
            >Perfil</a
          >
        </li>
        <li *ngIf="isAuthenticated()">
          <a
            routerLink="/user-list"
            routerLinkActive="bg-blue-700 "
            class="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
            >Pessoas</a
          >
        </li>
        <li *ngIf="isAuthenticated()">
          <a
            (click)="logout()"
            class="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
            >Sair</a
          >
        </li>
        <li *ngIf="!isAuthenticated()">
          <a
          routerLink="/login"
          routerLinkActive="bg-blue-700 "
          class="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 md:dark:hover:text-blue-500 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700"
            >Login</a
          >
        </li>
      </ul>
    </div>
  </div>
</nav>
<main
  (click)="collapseNavbar()"
  [class.iOS]="ios"
  class="relative bg-gray-50 dark:bg-gray-900 fill container flex flex-col items-stretch content-stretch justify-stretch justify-items-stretch place-content-stretch place-items-stretch"
>
  <router-outlet />
  <ui-toast />
  <ui-loading />
</main>

<footer class="bg-white rounded-lg shadow dark:bg-gray-900 w-full">
  <span
    class="block text-sm text-gray-500 sm:text-center dark:text-gray-400 p-4"
    >Desenvolvido com &hearts; pela
    <a (click)="openCapacitorSite()" href="https://trusom.com/" class="hover:underline" target="_blank"
      >trusom innovation</a
    >.</span
  >
</footer>
